import React, { createContext, useContext, useEffect, useState } from "react";
import HttpClient from "../utils/HttpClient";

const ProfileContext = createContext();

export const ProfileProvider = ({ children }) => {
    const [profile, setProfile] = useState(null);

    useEffect(() => {
        if(!profile) {
            // fetch profile data and setProfile
            (new HttpClient()).profile().then((response) => {
                console.log("ProfileProvider: setProfile", response);
                setProfile(response);
            });
        }
    }, [profile]);

    return (
        <ProfileContext.Provider value={{ profile, setProfile }}>
            {children}
        </ProfileContext.Provider>
    );
}

export const useProfile = () => {
    const context = useContext(ProfileContext);
    if (context === undefined) {
        throw new Error("useProfile must be used within a ProfileProvider");
    }
    return context;
}